//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class VideoLibraryApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    backup( cancelToken?: CancelToken): Promise<BackupDto> {
        let url_ = this.baseUrl + "/api/Backups/Backup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBackup(_response);
        });
    }

    protected processBackup(response: AxiosResponse): Promise<BackupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BackupDto.fromJS(resultData200);
            return Promise.resolve<BackupDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    restore(body: BackupBindingModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Backups/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param query (optional) 
     * @param categoryName (optional) 
     * @return OK
     */
    bookmarksGET(page: number | undefined, pageSize: number | undefined, query: string | undefined, categoryName: string | undefined, cancelToken?: CancelToken): Promise<BookmarkViewModelPaginatedResultsViewModel> {
        let url_ = this.baseUrl + "/api/Bookmarks?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (categoryName === null)
            throw new Error("The parameter 'categoryName' cannot be null.");
        else if (categoryName !== undefined)
            url_ += "CategoryName=" + encodeURIComponent("" + categoryName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarksGET(_response);
        });
    }

    protected processBookmarksGET(response: AxiosResponse): Promise<BookmarkViewModelPaginatedResultsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarkViewModelPaginatedResultsViewModel.fromJS(resultData200);
            return Promise.resolve<BookmarkViewModelPaginatedResultsViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarkViewModelPaginatedResultsViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bookmarksPOST(body: CreateBookmarksBindingModel | undefined, cancelToken?: CancelToken): Promise<CreateBookmarksResultViewModel> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarksPOST(_response);
        });
    }

    protected processBookmarksPOST(response: AxiosResponse): Promise<CreateBookmarksResultViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBookmarksResultViewModel.fromJS(resultData200);
            return Promise.resolve<CreateBookmarksResultViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBookmarksResultViewModel>(null as any);
    }

    /**
     * @return OK
     */
    bookmarksGET2(id: string, cancelToken?: CancelToken): Promise<BookmarkViewModel> {
        let url_ = this.baseUrl + "/api/Bookmarks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarksGET2(_response);
        });
    }

    protected processBookmarksGET2(response: AxiosResponse): Promise<BookmarkViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarkViewModel.fromJS(resultData200);
            return Promise.resolve<BookmarkViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarkViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bookmarksPUT(id: string, body: UpdateBookmarkBindingModel | undefined, cancelToken?: CancelToken): Promise<BookmarkViewModel> {
        let url_ = this.baseUrl + "/api/Bookmarks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarksPUT(_response);
        });
    }

    protected processBookmarksPUT(response: AxiosResponse): Promise<BookmarkViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarkViewModel.fromJS(resultData200);
            return Promise.resolve<BookmarkViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarkViewModel>(null as any);
    }

    /**
     * @return No Content
     */
    bookmarksDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarksDELETE(_response);
        });
    }

    protected processBookmarksDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    importAsVideo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks/{id}/ImportAsVideo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAsVideo(_response);
        });
    }

    protected processImportAsVideo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    rescanTitle(id: string, cancelToken?: CancelToken): Promise<BookmarkViewModel> {
        let url_ = this.baseUrl + "/api/Bookmarks/{id}/RescanTitle";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRescanTitle(_response);
        });
    }

    protected processRescanTitle(response: AxiosResponse): Promise<BookmarkViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarkViewModel.fromJS(resultData200);
            return Promise.resolve<BookmarkViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarkViewModel>(null as any);
    }

    /**
     * @return OK
     */
    categoriesAll( cancelToken?: CancelToken): Promise<CategoryWithCountsViewModel[]> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoriesAll(_response);
        });
    }

    protected processCategoriesAll(response: AxiosResponse): Promise<CategoryWithCountsViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryWithCountsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryWithCountsViewModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryWithCountsViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    categoriesPOST(body: CreateCategoryBindingModel | undefined, cancelToken?: CancelToken): Promise<NoContentResult> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoriesPOST(_response);
        });
    }

    protected processCategoriesPOST(response: AxiosResponse): Promise<NoContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = NoContentResult.fromJS(resultData204);
            return Promise.resolve<NoContentResult>(result204);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoContentResult>(null as any);
    }

    /**
     * @return OK
     */
    categoriesGET(name: string, cancelToken?: CancelToken): Promise<CategoryWithCountsViewModel> {
        let url_ = this.baseUrl + "/api/Categories/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoriesGET(_response);
        });
    }

    protected processCategoriesGET(response: AxiosResponse): Promise<CategoryWithCountsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryWithCountsViewModel.fromJS(resultData200);
            return Promise.resolve<CategoryWithCountsViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryWithCountsViewModel>(null as any);
    }

    /**
     * @return No Content
     */
    categoriesDELETE(name: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Categories/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoriesDELETE(_response);
        });
    }

    protected processCategoriesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoriesPUT(name: string, body: UpdateCategoryBindingModel | undefined, cancelToken?: CancelToken): Promise<CategoryWithCountsViewModel> {
        let url_ = this.baseUrl + "/api/Categories/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoriesPUT(_response);
        });
    }

    protected processCategoriesPUT(response: AxiosResponse): Promise<CategoryWithCountsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryWithCountsViewModel.fromJS(resultData200);
            return Promise.resolve<CategoryWithCountsViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryWithCountsViewModel>(null as any);
    }

    /**
     * @return OK
     */
    tagsAll( cancelToken?: CancelToken): Promise<TagWithVideoCountViewModel[]> {
        let url_ = this.baseUrl + "/api/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagsAll(_response);
        });
    }

    protected processTagsAll(response: AxiosResponse): Promise<TagWithVideoCountViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagWithVideoCountViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagWithVideoCountViewModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagWithVideoCountViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    videoResolver(body: ResolveVideoBindingModel | undefined, cancelToken?: CancelToken): Promise<ResolvedVideoViewModel> {
        let url_ = this.baseUrl + "/api/VideoResolver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideoResolver(_response);
        });
    }

    protected processVideoResolver(response: AxiosResponse): Promise<ResolvedVideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolvedVideoViewModel.fromJS(resultData200);
            return Promise.resolve<ResolvedVideoViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolvedVideoViewModel>(null as any);
    }

    /**
     * @return OK
     */
    videosGET(id: string, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideosGET(_response);
        });
    }

    protected processVideosGET(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }

    videosDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideosDELETE(_response);
        });
    }

    protected processVideosDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    videosPUT(id: string, body: UpdateVideoBindingModel | undefined, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideosPUT(_response);
        });
    }

    protected processVideosPUT(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchVideosOptionsBindingModel | undefined, cancelToken?: CancelToken): Promise<VideoViewModelPaginatedResultsViewModel> {
        let url_ = this.baseUrl + "/api/Videos/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<VideoViewModelPaginatedResultsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModelPaginatedResultsViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModelPaginatedResultsViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModelPaginatedResultsViewModel>(null as any);
    }

    /**
     * @return OK
     */
    deleted( cancelToken?: CancelToken): Promise<DeletedVideosViewModel> {
        let url_ = this.baseUrl + "/api/Videos/Deleted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleted(_response);
        });
    }

    protected processDeleted(response: AxiosResponse): Promise<DeletedVideosViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeletedVideosViewModel.fromJS(resultData200);
            return Promise.resolve<DeletedVideosViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletedVideosViewModel>(null as any);
    }

    /**
     * @return OK
     */
    pendingDeletion( cancelToken?: CancelToken): Promise<PendingDeletionViewModel> {
        let url_ = this.baseUrl + "/api/Videos/PendingDeletion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPendingDeletion(_response);
        });
    }

    protected processPendingDeletion(response: AxiosResponse): Promise<PendingDeletionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PendingDeletionViewModel.fromJS(resultData200);
            return Promise.resolve<PendingDeletionViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PendingDeletionViewModel>(null as any);
    }

    /**
     * @return OK
     */
    lastCleanupRun( cancelToken?: CancelToken): Promise<CleanupRunViewModel | null> {
        let url_ = this.baseUrl + "/api/Videos/LastCleanupRun";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLastCleanupRun(_response);
        });
    }

    protected processLastCleanupRun(response: AxiosResponse): Promise<CleanupRunViewModel | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CleanupRunViewModel.fromJS(resultData200);
            return Promise.resolve<CleanupRunViewModel | null>(result200);

        } else if (status === 204) {
            return Promise.resolve<CleanupRunViewModel | null>(null);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CleanupRunViewModel | null>(null);
    }

    /**
     * @param limit (optional) 
     * @return OK
     */
    cleanupRuns(limit: number | undefined, cancelToken?: CancelToken): Promise<CleanupRunViewModel[]> {
        let url_ = this.baseUrl + "/api/Videos/CleanupRuns?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCleanupRuns(_response);
        });
    }

    protected processCleanupRuns(response: AxiosResponse): Promise<CleanupRunViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CleanupRunViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CleanupRunViewModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CleanupRunViewModel[]>(null as any);
    }

    /**
     * @return No Content
     */
    resetAllRetries( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Videos/ResetAllRetries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAllRetries(_response);
        });
    }

    protected processResetAllRetries(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    resetRetries(id: string, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{id}/ResetRetries";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetRetries(_response);
        });
    }

    protected processResetRetries(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }

    /**
     * @return OK
     */
    restoreVideo(id: string, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{id}/Restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreVideo(_response);
        });
    }

    protected processRestoreVideo(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }

    /**
     * @return No Content
     */
    restoreVideos(ids: string[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Videos/RestoreVideos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify({ ids });

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreVideos(_response);
        });
    }

    protected processRestoreVideos(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    videosPOST(body: CreateVideosBindingModel | undefined, cancelToken?: CancelToken): Promise<CreateVideosResultViewModel> {
        let url_ = this.baseUrl + "/api/Videos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideosPOST(_response);
        });
    }

    protected processVideosPOST(response: AxiosResponse): Promise<CreateVideosResultViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateVideosResultViewModel.fromJS(resultData200);
            return Promise.resolve<CreateVideosResultViewModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateVideosResultViewModel>(null as any);
    }

    /**
     * @return No Content
     */
    rescan(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Videos/{id}/Rescan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRescan(_response);
        });
    }

    protected processRescan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleFavourite(id: string, body: BooleanBindingModel | undefined, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{id}/ToggleFavourite";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleFavourite(_response);
        });
    }

    protected processToggleFavourite(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }

    /**
     * @return OK
     */
    thumbnail(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Videos/{id}/Thumbnail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThumbnail(_response);
        });
    }

    protected processThumbnail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tags(videoId: string, body: ToggleVideoTagBindingModel | undefined, cancelToken?: CancelToken): Promise<VideoViewModel> {
        let url_ = this.baseUrl + "/api/Videos/{videoId}/Tags";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTags(_response);
        });
    }

    protected processTags(response: AxiosResponse): Promise<VideoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoViewModel.fromJS(resultData200);
            return Promise.resolve<VideoViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoViewModel>(null as any);
    }
}

export class BackupBindingModel implements IBackupBindingModel {

    constructor(data?: IBackupBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BackupBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBackupBindingModel {
}

export class BackupBookmarkDto implements IBackupBookmarkDto {
    name?: string | null;
    categoryName?: string | null;
    url?: string | null;

    constructor(data?: IBackupBookmarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): BackupBookmarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackupBookmarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IBackupBookmarkDto {
    name?: string | null;
    categoryName?: string | null;
    url?: string | null;
}

export class BackupCategoryDto implements IBackupCategoryDto {
    name?: string | null;

    constructor(data?: IBackupCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): BackupCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackupCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IBackupCategoryDto {
    name?: string | null;
}

export class BackupDto implements IBackupDto {
    bookmarks?: BackupBookmarkDto[] | null;
    categories?: BackupCategoryDto[] | null;
    videos?: BackupVideoDto[] | null;

    constructor(data?: IBackupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookmarks"])) {
                this.bookmarks = [] as any;
                for (let item of _data["bookmarks"])
                    this.bookmarks!.push(BackupBookmarkDto.fromJS(item));
            }
            else {
                this.bookmarks = <any>null;
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(BackupCategoryDto.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(BackupVideoDto.fromJS(item));
            }
            else {
                this.videos = <any>null;
            }
        }
    }

    static fromJS(data: any): BackupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookmarks)) {
            data["bookmarks"] = [];
            for (let item of this.bookmarks)
                data["bookmarks"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBackupDto {
    bookmarks?: BackupBookmarkDto[] | null;
    categories?: BackupCategoryDto[] | null;
    videos?: BackupVideoDto[] | null;
}

export class BackupVideoDto implements IBackupVideoDto {
    title?: string | null;
    durationInSeconds?: number | null;
    provider?: string | null;
    publishedDate?: Date | null;
    tags?: string[] | null;
    categoryName?: string | null;
    thumbnailUrl?: string | null;
    url?: string | null;

    constructor(data?: IBackupVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.durationInSeconds = _data["durationInSeconds"] !== undefined ? _data["durationInSeconds"] : <any>null;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : <any>null;
            this.publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.thumbnailUrl = _data["thumbnailUrl"] !== undefined ? _data["thumbnailUrl"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): BackupVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackupVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["durationInSeconds"] = this.durationInSeconds !== undefined ? this.durationInSeconds : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["thumbnailUrl"] = this.thumbnailUrl !== undefined ? this.thumbnailUrl : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IBackupVideoDto {
    title?: string | null;
    durationInSeconds?: number | null;
    provider?: string | null;
    publishedDate?: Date | null;
    tags?: string[] | null;
    categoryName?: string | null;
    thumbnailUrl?: string | null;
    url?: string | null;
}

export class BookmarkViewModel implements IBookmarkViewModel {
    readonly id?: string;
    readonly name?: string | null;
    readonly categoryName?: string | null;
    readonly url?: string | null;
    readonly createdDate?: Date;
    readonly updatedDate?: Date | null;

    constructor(data?: IBookmarkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            (<any>this).url = _data["url"] !== undefined ? _data["url"] : <any>null;
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BookmarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IBookmarkViewModel {
    id?: string;
    name?: string | null;
    categoryName?: string | null;
    url?: string | null;
    createdDate?: Date;
    updatedDate?: Date | null;
}

export class BookmarkViewModelPaginatedResultsViewModel implements IBookmarkViewModelPaginatedResultsViewModel {
    page?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    results?: BookmarkViewModel[] | null;

    constructor(data?: IBookmarkViewModelPaginatedResultsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BookmarkViewModel.fromJS(item));
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): BookmarkViewModelPaginatedResultsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkViewModelPaginatedResultsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookmarkViewModelPaginatedResultsViewModel {
    page?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    results?: BookmarkViewModel[] | null;
}

export class BooleanBindingModel implements IBooleanBindingModel {
    value?: boolean;

    constructor(data?: IBooleanBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): BooleanBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IBooleanBindingModel {
    value?: boolean;
}

export class CategoryWithCountsViewModel implements ICategoryWithCountsViewModel {
    readonly name?: string | null;
    readonly bookmarkCount?: number;
    readonly videoCount?: number;

    constructor(data?: ICategoryWithCountsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).bookmarkCount = _data["bookmarkCount"] !== undefined ? _data["bookmarkCount"] : <any>null;
            (<any>this).videoCount = _data["videoCount"] !== undefined ? _data["videoCount"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryWithCountsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithCountsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["bookmarkCount"] = this.bookmarkCount !== undefined ? this.bookmarkCount : <any>null;
        data["videoCount"] = this.videoCount !== undefined ? this.videoCount : <any>null;
        return data;
    }
}

export interface ICategoryWithCountsViewModel {
    name?: string | null;
    bookmarkCount?: number;
    videoCount?: number;
}

export class CreateBookmarkBindingModel implements ICreateBookmarkBindingModel {
    url!: string;
    categoryName?: string | null;
    title?: string | null;

    constructor(data?: ICreateBookmarkBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateBookmarkBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookmarkBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface ICreateBookmarkBindingModel {
    url: string;
    categoryName?: string | null;
    title?: string | null;
}

export class CreateBookmarksBindingModel implements ICreateBookmarksBindingModel {
    bookmarks!: CreateBookmarkBindingModel[];

    constructor(data?: ICreateBookmarksBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bookmarks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookmarks"])) {
                this.bookmarks = [] as any;
                for (let item of _data["bookmarks"])
                    this.bookmarks!.push(CreateBookmarkBindingModel.fromJS(item));
            }
            else {
                this.bookmarks = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateBookmarksBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookmarksBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookmarks)) {
            data["bookmarks"] = [];
            for (let item of this.bookmarks)
                data["bookmarks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateBookmarksBindingModel {
    bookmarks: CreateBookmarkBindingModel[];
}

export class CreateBookmarksResultViewModel implements ICreateBookmarksResultViewModel {
    addedBookmarks?: BookmarkViewModel[] | null;
    failedBookmarks?: FailedBookmarkCreationViewModel[] | null;

    constructor(data?: ICreateBookmarksResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addedBookmarks"])) {
                this.addedBookmarks = [] as any;
                for (let item of _data["addedBookmarks"])
                    this.addedBookmarks!.push(BookmarkViewModel.fromJS(item));
            }
            else {
                this.addedBookmarks = <any>null;
            }
            if (Array.isArray(_data["failedBookmarks"])) {
                this.failedBookmarks = [] as any;
                for (let item of _data["failedBookmarks"])
                    this.failedBookmarks!.push(FailedBookmarkCreationViewModel.fromJS(item));
            }
            else {
                this.failedBookmarks = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateBookmarksResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookmarksResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addedBookmarks)) {
            data["addedBookmarks"] = [];
            for (let item of this.addedBookmarks)
                data["addedBookmarks"].push(item.toJSON());
        }
        if (Array.isArray(this.failedBookmarks)) {
            data["failedBookmarks"] = [];
            for (let item of this.failedBookmarks)
                data["failedBookmarks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateBookmarksResultViewModel {
    addedBookmarks?: BookmarkViewModel[] | null;
    failedBookmarks?: FailedBookmarkCreationViewModel[] | null;
}

export class CreateCategoryBindingModel implements ICreateCategoryBindingModel {
    name!: string;

    constructor(data?: ICreateCategoryBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCategoryBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICreateCategoryBindingModel {
    name: string;
}

export class CreateVideoBindingModel implements ICreateVideoBindingModel {
    url!: string;
    categoryName?: string | null;
    title?: string | null;

    constructor(data?: ICreateVideoBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateVideoBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideoBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface ICreateVideoBindingModel {
    url: string;
    categoryName?: string | null;
    title?: string | null;
}

export class CreateVideosBindingModel implements ICreateVideosBindingModel {
    videos!: CreateVideoBindingModel[];

    constructor(data?: ICreateVideosBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.videos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(CreateVideoBindingModel.fromJS(item));
            }
            else {
                this.videos = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateVideosBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideosBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateVideosBindingModel {
    videos: CreateVideoBindingModel[];
}

export class CreateVideosResultViewModel implements ICreateVideosResultViewModel {
    addedVideos?: VideoViewModel[] | null;
    failedVideos?: FailedVideoCreationViewModel[] | null;

    constructor(data?: ICreateVideosResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addedVideos"])) {
                this.addedVideos = [] as any;
                for (let item of _data["addedVideos"])
                    this.addedVideos!.push(VideoViewModel.fromJS(item));
            }
            else {
                this.addedVideos = <any>null;
            }
            if (Array.isArray(_data["failedVideos"])) {
                this.failedVideos = [] as any;
                for (let item of _data["failedVideos"])
                    this.failedVideos!.push(FailedVideoCreationViewModel.fromJS(item));
            }
            else {
                this.failedVideos = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateVideosResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideosResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addedVideos)) {
            data["addedVideos"] = [];
            for (let item of this.addedVideos)
                data["addedVideos"].push(item.toJSON());
        }
        if (Array.isArray(this.failedVideos)) {
            data["failedVideos"] = [];
            for (let item of this.failedVideos)
                data["failedVideos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateVideosResultViewModel {
    addedVideos?: VideoViewModel[] | null;
    failedVideos?: FailedVideoCreationViewModel[] | null;
}

export class FailedBookmarkCreationViewModel implements IFailedBookmarkCreationViewModel {
    url?: string | null;
    reason?: string | null;

    constructor(data?: IFailedBookmarkCreationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): FailedBookmarkCreationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FailedBookmarkCreationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IFailedBookmarkCreationViewModel {
    url?: string | null;
    reason?: string | null;
}

export class FailedVideoCreationViewModel implements IFailedVideoCreationViewModel {
    url?: string | null;
    reason?: string | null;

    constructor(data?: IFailedVideoCreationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): FailedVideoCreationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FailedVideoCreationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IFailedVideoCreationViewModel {
    url?: string | null;
    reason?: string | null;
}

export class NoContentResult implements INoContentResult {
    statusCode?: number;

    constructor(data?: INoContentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : <any>null;
        }
    }

    static fromJS(data: any): NoContentResult {
        data = typeof data === 'object' ? data : {};
        let result = new NoContentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        return data;
    }
}

export interface INoContentResult {
    statusCode?: number;
}

export class DeletedVideosViewModel implements IDeletedVideosViewModel {
    totalCount?: number;
    videos?: VideoViewModel[] | null;

    constructor(data?: IDeletedVideosViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoViewModel.fromJS(item));
            }
            else {
                this.videos = <any>null;
            }
        }
    }

    static fromJS(data: any): DeletedVideosViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedVideosViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeletedVideosViewModel {
    totalCount?: number;
    videos?: VideoViewModel[] | null;
}

export class PendingDeletionViewModel implements IPendingDeletionViewModel {
    retriesBeforeRemoval?: number;
    totalCount?: number;
    videos?: VideoViewModel[] | null;

    constructor(data?: IPendingDeletionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retriesBeforeRemoval = _data["retriesBeforeRemoval"] !== undefined ? _data["retriesBeforeRemoval"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoViewModel.fromJS(item));
            }
            else {
                this.videos = <any>null;
            }
        }
    }

    static fromJS(data: any): PendingDeletionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingDeletionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retriesBeforeRemoval"] = this.retriesBeforeRemoval !== undefined ? this.retriesBeforeRemoval : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPendingDeletionViewModel {
    retriesBeforeRemoval?: number;
    totalCount?: number;
    videos?: VideoViewModel[] | null;
}

export class CleanupRunViewModel implements ICleanupRunViewModel {
    runDate?: Date;
    videosChecked?: number;
    videosRemoved?: number;
    succeeded?: boolean;

    constructor(data?: ICleanupRunViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runDate = _data["runDate"] ? new Date(_data["runDate"].toString()) : <any>null;
            this.videosChecked = _data["videosChecked"] !== undefined ? _data["videosChecked"] : <any>null;
            this.videosRemoved = _data["videosRemoved"] !== undefined ? _data["videosRemoved"] : <any>null;
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : <any>null;
        }
    }

    static fromJS(data: any): CleanupRunViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanupRunViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runDate"] = this.runDate ? this.runDate.toISOString() : <any>null;
        data["videosChecked"] = this.videosChecked !== undefined ? this.videosChecked : <any>null;
        data["videosRemoved"] = this.videosRemoved !== undefined ? this.videosRemoved : <any>null;
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : <any>null;
        return data;
    }
}

export interface ICleanupRunViewModel {
    runDate?: Date;
    videosChecked?: number;
    videosRemoved?: number;
    succeeded?: boolean;
}

export class ResolveVideoBindingModel implements IResolveVideoBindingModel {
    url!: string;

    constructor(data?: IResolveVideoBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): ResolveVideoBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveVideoBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IResolveVideoBindingModel {
    url: string;
}

export class ResolvedVideoViewModel implements IResolvedVideoViewModel {
    readonly title?: string | null;

    constructor(data?: IResolvedVideoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ResolvedVideoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedVideoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IResolvedVideoViewModel {
    title?: string | null;
}

export class SearchVideosOptionsBindingModel implements ISearchVideosOptionsBindingModel {
    categoryName?: string | null;
    query?: string | null;
    page?: number | null;
    pageSize?: number | null;
    tags?: string[] | null;
    sortDirection?: SortDirection;
    sortType?: VideoSortType;

    constructor(data?: ISearchVideosOptionsBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
            this.sortType = _data["sortType"] !== undefined ? _data["sortType"] : <any>null;
        }
    }

    static fromJS(data: any): SearchVideosOptionsBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVideosOptionsBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["sortType"] = this.sortType !== undefined ? this.sortType : <any>null;
        return data;
    }
}

export interface ISearchVideosOptionsBindingModel {
    categoryName?: string | null;
    query?: string | null;
    page?: number | null;
    pageSize?: number | null;
    tags?: string[] | null;
    sortDirection?: SortDirection;
    sortType?: VideoSortType;
}

export enum SortDirection {
    _0 = 0,
    _1 = 1,
}

export enum TagAction {
    _0 = 0,
    _1 = 1,
}

export class TagWithVideoCountViewModel implements ITagWithVideoCountViewModel {
    readonly name?: string | null;
    readonly videoCount?: number;
    readonly createdDate?: Date;
    readonly updatedDate?: Date;

    constructor(data?: ITagWithVideoCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).videoCount = _data["videoCount"] !== undefined ? _data["videoCount"] : <any>null;
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TagWithVideoCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagWithVideoCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["videoCount"] = this.videoCount !== undefined ? this.videoCount : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface ITagWithVideoCountViewModel {
    name?: string | null;
    videoCount?: number;
    createdDate?: Date;
    updatedDate?: Date;
}

export class ToggleVideoTagBindingModel implements IToggleVideoTagBindingModel {
    name!: string;
    action!: TagAction;

    constructor(data?: IToggleVideoTagBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleVideoTagBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleVideoTagBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        return data;
    }
}

export interface IToggleVideoTagBindingModel {
    name: string;
    action: TagAction;
}

export class UpdateBookmarkBindingModel implements IUpdateBookmarkBindingModel {
    categoryName?: string | null;
    name!: string;

    constructor(data?: IUpdateBookmarkBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateBookmarkBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookmarkBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IUpdateBookmarkBindingModel {
    categoryName?: string | null;
    name: string;
}

export class UpdateCategoryBindingModel implements IUpdateCategoryBindingModel {
    name!: string;

    constructor(data?: IUpdateCategoryBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCategoryBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IUpdateCategoryBindingModel {
    name: string;
}

export class UpdateVideoBindingModel implements IUpdateVideoBindingModel {
    title!: string;
    categoryName?: string | null;

    constructor(data?: IUpdateVideoBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVideoBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVideoBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        return data;
    }
}

export interface IUpdateVideoBindingModel {
    title: string;
    categoryName?: string | null;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;
}

export enum VideoSortType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class VideoViewModel implements IVideoViewModel {
    readonly id?: string;
    readonly provider?: string | null;
    readonly categoryName?: string | null;
    readonly durationInSeconds?: number | null;
    readonly publishedDate?: Date | null;
    readonly thumbnailUrl?: string | null;
    readonly title?: string | null;
    readonly url?: string | null;
    readonly retries?: number;
    readonly isFavourite?: boolean;
    readonly tags?: string[] | null;
    readonly createdDate?: Date;
    readonly updatedDate?: Date | null;
    readonly deletedDate?: Date | null;
    readonly lastFailureReason?: string | null;
    readonly lastFailureHtml?: string | null;
    readonly lastFailureDate?: Date | null;

    constructor(data?: IVideoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).provider = _data["provider"] !== undefined ? _data["provider"] : <any>null;
            (<any>this).categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            (<any>this).durationInSeconds = _data["durationInSeconds"] !== undefined ? _data["durationInSeconds"] : <any>null;
            (<any>this).publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : <any>null;
            (<any>this).thumbnailUrl = _data["thumbnailUrl"] !== undefined ? _data["thumbnailUrl"] : <any>null;
            (<any>this).title = _data["title"] !== undefined ? _data["title"] : <any>null;
            (<any>this).url = _data["url"] !== undefined ? _data["url"] : <any>null;
            (<any>this).retries = _data["retries"] !== undefined ? _data["retries"] : <any>null;
            (<any>this).isFavourite = _data["isFavourite"] !== undefined ? _data["isFavourite"] : <any>null;
            if (Array.isArray(_data["tags"])) {
                (<any>this).tags = [] as any;
                for (let item of _data["tags"])
                    (<any>this).tags!.push(item);
            }
            else {
                (<any>this).tags = <any>null;
            }
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            (<any>this).deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>null;
            (<any>this).lastFailureReason = _data["lastFailureReason"] !== undefined ? _data["lastFailureReason"] : <any>null;
            (<any>this).lastFailureHtml = _data["lastFailureHtml"] !== undefined ? _data["lastFailureHtml"] : <any>null;
            (<any>this).lastFailureDate = _data["lastFailureDate"] ? new Date(_data["lastFailureDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): VideoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["durationInSeconds"] = this.durationInSeconds !== undefined ? this.durationInSeconds : <any>null;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : <any>null;
        data["thumbnailUrl"] = this.thumbnailUrl !== undefined ? this.thumbnailUrl : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["retries"] = this.retries !== undefined ? this.retries : <any>null;
        data["isFavourite"] = this.isFavourite !== undefined ? this.isFavourite : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>null;
        data["lastFailureReason"] = this.lastFailureReason !== undefined ? this.lastFailureReason : <any>null;
        data["lastFailureHtml"] = this.lastFailureHtml !== undefined ? this.lastFailureHtml : <any>null;
        data["lastFailureDate"] = this.lastFailureDate ? this.lastFailureDate.toISOString() : <any>null;
        return data;
    }
}

export interface IVideoViewModel {
    id?: string;
    provider?: string | null;
    categoryName?: string | null;
    durationInSeconds?: number | null;
    publishedDate?: Date | null;
    thumbnailUrl?: string | null;
    title?: string | null;
    url?: string | null;
    retries?: number;
    isFavourite?: boolean;
    tags?: string[] | null;
    createdDate?: Date;
    updatedDate?: Date | null;
    deletedDate?: Date | null;
    lastFailureReason?: string | null;
    lastFailureHtml?: string | null;
    lastFailureDate?: Date | null;
}

export class VideoViewModelPaginatedResultsViewModel implements IVideoViewModelPaginatedResultsViewModel {
    page?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    results?: VideoViewModel[] | null;

    constructor(data?: IVideoViewModelPaginatedResultsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(VideoViewModel.fromJS(item));
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): VideoViewModelPaginatedResultsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoViewModelPaginatedResultsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVideoViewModelPaginatedResultsViewModel {
    page?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    results?: VideoViewModel[] | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}